import { useRouter } from 'next/router';
import React, { ReactElement } from 'react';

import { useGetJobInstance } from '@/modules/workingDay/apiHooks';
import Header from '@/modules/workingDay/components/Details/Header';
import Notes from '@/modules/workingDay/components/Details/Notes';
import TeamList from '@/modules/workingDay/components/Details/TeamList';
import { useStore } from '@/shared/hooks/context/createGenericContext';

export default function WorkingDayDetails(): ReactElement {
  const { query } = useRouter();
  const { id } = query;
  const [selectedAsset] = useStore((store) => store?.asset);

  const { data, isLoading } = useGetJobInstance({
    entityId: selectedAsset?.id,
    jobInstanceId: id?.toString(),
  });

  return isLoading ? (
    <></>
  ) : (
    <section className='flex flex-col gap-48'>
      <Header instance={data?.jobInstance} suppliers={data?.suppliers || []} />
      <Notes
        startNote={data?.jobInstance.startNote}
        endNote={data?.jobInstance.endNote}
      />
      <TeamList
        list={data?.suppliers || []}
        productivityMeasurementUnit={
          data?.jobInstance?.productivityMeasurementUnit || ''
        }
      />
    </section>
  );
}
